import {useSyncExternalStore} from 'react';

import {createPairableCallStore} from '../utils/createPairableCallStore';

/** One per tab, shared by the call indicator, the after-call card and the record pages. */
const pairableCallStore = createPairableCallStore();

/** The viewer's call the after-call card pairs, and the records opened since it started. */
export function usePairableCall() {
  const state = useSyncExternalStore(pairableCallStore.subscribe, pairableCallStore.getState);

  return {state, store: pairableCallStore};
}
